import React from 'react';
import './ProjectCard.css'; // Add your CSS styles here

const formatDate = (dateString) => {
  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
};

const formatBudget = (budget) => {
  const budgetNumber = parseFloat(budget);
  return budgetNumber % 1 === 0 ? `${budgetNumber.toFixed(0)} mille dinars` : `${budgetNumber.toFixed(2)} mille dinars`;
};
const ProjectCard = ({ title, photo, zone, startDate, duration, budget, bailleur, globalObjective, specificObjectives }) => {
  return (
    <div className="project-card">
      <h3 className="project-title">{title}</h3>
      <div className="project-content">
        <div className="project-photo-container">
          {photo && <img className="project-photo" src={photo} alt={title} />}
        </div>
        <div className="project-details">
          <p><strong>Zone d'intervention :</strong> {zone}</p>
          <p><strong>Date de début :</strong> {formatDate(startDate)}</p>
          <p><strong>Durée :</strong> {duration}</p>
          <p><strong>Budget :</strong> {formatBudget(budget)}</p>
          <p><strong>Bailleur :</strong> {bailleur}</p>
          <p><strong>Objectif global :</strong> {globalObjective}</p>
          <p><strong>Objectifs spécifiques :</strong></p>
          <ul className="no-bullets">
            {specificObjectives.split('\n').map((objective, index) => (
              <li key={index}>{objective}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;